
import React from 'react'
import { Clear } from "@mui/icons-material"

import "./customicons.css"

export const CancelIcon = ({ disabled, onClick }) => {

  return (
   
    <div>
      <Clear className= "iconCancel" sx={{ fontSize: 20 }} onClick = {onClick}/>
    </div> 

  )
}
  




